export var ListActiveFilter;
(function (ListActiveFilter) {
    ListActiveFilter["ACTIVE"] = "ACTIVE";
    ListActiveFilter["INACTIVE"] = "INACTIVE";
    ListActiveFilter["ALL"] = "ALL";
})(ListActiveFilter || (ListActiveFilter = {}));
//# sourceMappingURL=list-active-filter.js.map